/**
 * Orientação discreta para upload de imagem (etapas e modelos na recuperação de PIX).
 */
export function RecoveryImageUploadHint({ className = "" }) {
  return (
    <div className={`rounded-lg border border-white/[0.06] bg-black/20 px-3 py-2.5 ${className}`.trim()}>
      <p className="text-[10px] font-medium uppercase tracking-wider text-slate-500">Tamanhos recomendados</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        <span className="rounded-md border border-emerald-500/20 bg-emerald-500/[0.07] px-2 py-0.5 text-[11px] tabular-nums text-emerald-200/90">
          1080 × 1350
          <span className="ml-1 font-normal text-emerald-400/75">recomendado</span>
        </span>
        <span className="rounded-md border border-white/[0.07] bg-white/[0.03] px-2 py-0.5 text-[11px] tabular-nums text-slate-500">
          1080 × 1080 · quadrado
        </span>
        <span className="rounded-md border border-white/[0.07] bg-white/[0.03] px-2 py-0.5 text-[11px] tabular-nums text-slate-500">
          1200 × 628 · horizontal
        </span>
      </div>
      <div className="mt-2 space-y-0.5 text-[11px] leading-snug text-slate-600">
        <p>Formatos: JPG e PNG</p>
        <p>Tamanho máximo: 5 MB</p>
        <p>Dica: prefira imagem nítida e texto legível</p>
      </div>
    </div>
  );
}
